import type { ProspectInList } from "@/models/ProspectInList";
import type { Axios } from "axios";
import type { UseQueryOptions } from "@tanstack/react-query";

export const getProspectsListForUser = async (
  axiosInstance: Axios
): Promise<ProspectInList[]> => {
  try {
    const response =
      await axiosInstance.get<ProspectInList[]>("/prospects/list");
    return response.data;
  } catch (error) {
    console.error("Error fetching prospects:", error);
    throw error;
  }
};

export const getProspectsListForUserQuery = (
  axiosInstance: Axios
): UseQueryOptions<ProspectInList[]> => ({
  queryKey: ["prospectsList"],
  queryFn: () => getProspectsListForUser(axiosInstance)
});
